module.exports = __webpack_public_path__ + "static/easter-03096f1da7460db6e2a8a10f1a990146.jpg";